// @ts-strict-ignore
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { LMSimpleProgressService } from '@field/simpleprogress/lm-simple-progress.service';

@Component({
  selector: 'lm-simple-progress',
  templateUrl: './lm-simple-progress.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class LMSimpleProgressComponent implements OnInit {

  @Input() lmProgressFieldData: LMProgressFieldData;

  public width: number;
  public displayValue: string;
  public title: string;
  public colorClass: string;
  public inverseClass = '';

  constructor( private lmSimpleProgressService: LMSimpleProgressService ) { }

  ngOnInit() {
    this.width = this.lmSimpleProgressService.getWidth(this.lmProgressFieldData);
    this.displayValue = this.lmSimpleProgressService.getDisplayValue(this.lmProgressFieldData);
    this.title = this.lmSimpleProgressService.getTitle(this.lmProgressFieldData);
    this.colorClass = this.lmSimpleProgressService.getColorClass(this.lmProgressFieldData);
    this.inverseClass = this.lmSimpleProgressService.getInverseClass(this.lmProgressFieldData);
  }
}
